module.exports = __webpack_public_path__ + "static/media/fgp.eb3ded06.png";